export default __webpack_public_path__ + "tmp_src/components/PredictiveSearch/PredictiveSearch~aurora.css.liquid";